import { render, staticRenderFns } from "./CreditNotification.vue?vue&type=template&id=ff9b5ae4&lang=html"
import script from "./CreditNotification.vue?vue&type=script&lang=js"
export * from "./CreditNotification.vue?vue&type=script&lang=js"
import style0 from "./CreditNotification.vue?vue&type=style&index=0&id=ff9b5ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports